import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';

import { WorkersSectionsEnum } from '../enums';
import WorkerSection from './WorkersSection';
import useQueryMatch from 'hooks/useQueryMatch';
import ContractorCompaniesSection from './ContractorCompaniesSection';
import { isAdminSelector } from 'redux/selectors/authenticationSelectors';
import AdminContractorCompaniesSection from 'features/admin/contractorCompany/AdminContractorCompaniesSection';
import { useAppSelector } from 'hooks/useAppSelector';

const getDefaultSection = (isAdmin?: boolean) => {
  return isAdmin ? WorkersSectionsEnum.Approved : WorkersSectionsEnum.Workers;
};

const getPageSections = (isAdmin?: boolean) => {
  return isAdmin
    ? [WorkersSectionsEnum.Approved, WorkersSectionsEnum.ContractorCompanies]
    : [WorkersSectionsEnum.Workers, WorkersSectionsEnum.ContractorCompanies];
};

export default function WorkersPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const isAdmin = useAppSelector(isAdminSelector);
  const query = queryString.parse(location.search);
  const pageSectionMatch = useQueryMatch(getPageSections(isAdmin));

  useEffect(() => {
    if (!pageSectionMatch) {
      navigate(`${location.pathname}?section=${getDefaultSection(isAdmin)}`, {
        replace: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSectionMatch]);

  const getSection = () => {
    switch (query.section) {
      case WorkersSectionsEnum.ContractorCompanies:
        return isAdmin ? (
          <AdminContractorCompaniesSection />
        ) : (
          <ContractorCompaniesSection />
        );

      case WorkersSectionsEnum.Workers:
      default:
        return <WorkerSection />;
    }
  };

  return <>{getSection()}</>;
}
